import Icon from '@ant-design/icons';
import { Spin, TreeSelect, TreeSelectProps } from 'antd';
import { ArrowDownIcon, LoupIcon } from 'assets';
import React, { useState } from 'react';
import { useGetOrganizationUnitChangeOptionsQuery } from 'services';
import { FindOrganizationUnitHierarchyDto, OrganizationUnitHierarchyCompactDto } from 'types';

type TreeSelectOrganizationUnitsProps = TreeSelectProps & FindOrganizationUnitHierarchyDto;

const TreeSelectOrganizationUnitChangeOptions: React.FC<TreeSelectOrganizationUnitsProps> = ({
  parentId,
  organizationUnitId,
  showCheckedStrategy = 'SHOW_PARENT',
  treeCheckable = true,
  ...props
}) => {
  const [keyword, setKeyword] = useState('');

  const { data: organizationsUnitsHierarchy, isLoading } = useGetOrganizationUnitChangeOptionsQuery({
    keyword,
    parentId,
    organizationUnitId
  });

  const handleSearch = (val: string) => {
    setKeyword(val);
  };
  const transformData = (treeData: OrganizationUnitHierarchyCompactDto[]): any[] => {
    if (treeData.length === 0) return [];

    return treeData.map((org) => ({
      title: org.name,
      value: org.organizationUnitId,
      key: org.organizationUnitId,
      children: org.children?.length ? transformData(org.children) : [],
      disabled: org.organizationUnitId === 1
    }));
  };

  return (
    <TreeSelect
      {...props}
      loading={isLoading}
      onSearch={handleSearch}
      filterTreeNode={false}
      showCheckedStrategy={showCheckedStrategy}
      treeData={transformData(organizationsUnitsHierarchy?.data ?? [])}
      suffixIcon={
        isLoading ? (
          <Spin spinning />
        ) : (
          <Icon component={props.showSearch ? LoupIcon : ArrowDownIcon} className='text-colorTextPlaceholder' />
        )
      }
    />
  );
};
export default TreeSelectOrganizationUnitChangeOptions;
